module.exports = __webpack_public_path__ + "static/media/archButton.30a1257a.png";